import i18n from '@/i18n'
import { mapActions} from 'vuex'
import { DialogType } from '@/constants/constants'

export default {
    name: 'ScoringDialogSecondLevelTabComponent',
    components: {
    },
    model: {
        prop: 'model',
        event: 'change'
    },
    props: {
        model: {
            type: Object,
            required: true
        },
        validationRules: {
            type: Object,
            required: true
        },
        validForm: {
            type: Boolean,
            required: true
        },
        resetFormValidation: {
            type: Boolean,
            required: true
        },
        viewMode: {
            type: Boolean,
            required: true
        }
    },
    data: () => ({
        // model para el formulario de la tabla (ventana horaria)
        tableValidForm: false,
        // model para el formulario de infracción
        infractionValidForm: false,
        // infracciones
        infractions: [
            {
                id: 'hardBraking',
                name: i18n.t('scoring.editDialog.hardBraking')
            },
            {
                id: 'acceleration',
                name: i18n.t('scoring.editDialog.acceleration')
            },
            {
                id: 'corneringAcceleration',
                name: i18n.t('scoring.editDialog.corneringAcceleration')
            },
            {
                id: 'disconnection',
                name: i18n.t('scoring.editDialog.disconnection')
            }
        ],
        // infracción seleccionada para editar
        infraction: null,
        // modelo de datos para el formulario
        infractionModel: {
            sligth: {
                range: {
                    min: 0,
                    max: null
                },
                weightedValue: null
            },
            medium: {
                range: {
                    min: null,
                    max: null
                },
                weightedValue: null
            },
            serious: {
                range: {
                    min: null,
                    max: null
                },
                weightedValue: null
            }
        },
        // headers de la tabla de resumen
        headers: [
            {
                text: i18n.t('scoring.editDialog.name'),
                align: 'left',
                sortable: false,
                value: 'name',
                width: 150
            },
            {
                text: i18n.t('scoring.editDialog.range'),
                align: 'right',
                sortable: false,
                value: 'sligthRange',
                class: 'header-sligth',
                width: 150
            },
            {
                text: i18n.t('scoring.editDialog.weightedValue'),
                align: 'right',
                sortable: false,
                value: 'sligthWeightedValue',
                class: 'header-sligth',
                width: 100
            },
            {
                text: i18n.t('scoring.editDialog.range'),
                align: 'right',
                sortable: false,
                value: 'mediumRange',
                class: 'header-medium',
                width: 150
            },
            {
                text: i18n.t('scoring.editDialog.weightedValue'),
                align: 'right',
                sortable: false,
                value: 'mediumWeightedValue',
                class: 'header-medium',
                width: 100
            },
            {
                text: i18n.t('scoring.editDialog.range'),
                align: 'right',
                sortable: false,
                value: 'seriousRange',
                class: 'header-serious',
                width: 150
            },
            {
                text: i18n.t('scoring.editDialog.weightedValue'),
                align: 'right',
                sortable: false,
                value: 'seriousWeightedValue',
                class: 'header-serious',
                width: 100
            }
        ]
    }),
    computed: {
        /**
         * Datos de la tabla
         */
        tableData () {
            const data = []
            this.infractions.forEach(element => {
                data.push({
                    id: element.id,
                    name: element.name,
                    sligthRange: this.model[element.id].sligth.range.min != null && this.model[element.id].sligth.range.max != null
                        ? this.$t('scoring.editDialog.betweenAnd', { between: this.model[element.id].sligth.range.min, and: this.model[element.id].sligth.range.max })
                        : null,
                    sligthWeightedValue: this.model[element.id].sligth.weightedValue != null
                        ? this.model[element.id].sligth.weightedValue
                        : null,
                    mediumRange: this.model[element.id].medium.range.min != null && this.model[element.id].medium.range.max != null
                        ? this.$t('scoring.editDialog.betweenAnd', { between: this.model[element.id].medium.range.min, and: this.model[element.id].medium.range.max })
                        : null,
                    mediumWeightedValue: this.model[element.id].medium.weightedValue != null
                        ? this.model[element.id].medium.weightedValue
                        : null,
                    seriousRange: this.model[element.id].serious.range.min != null
                        ? `${this.$t('scoring.editDialog.moreThan')} ${this.model[element.id].serious.range.min}`
                        : null,
                    seriousWeightedValue: this.model[element.id].serious.weightedValue != null
                        ? this.model[element.id].serious.weightedValue
                        : null
                })
            })
            return data
        },
        /**
         * Retorna un boolean referido al estado de guardado del formulario
         */
        notSaved () {
            return this.infraction && this.model[this.infraction] && (
                this.infractionModel.sligth.range.min !== this.model[this.infraction].sligth.range.min
                || this.infractionModel.sligth.range.max !== this.model[this.infraction].sligth.range.max
                || this.infractionModel.sligth.weightedValue !== this.model[this.infraction].sligth.weightedValue
                || this.infractionModel.medium.range.min !== this.model[this.infraction].medium.range.min
                || this.infractionModel.medium.range.max !== this.model[this.infraction].medium.range.max
                || this.infractionModel.medium.weightedValue !== this.model[this.infraction].medium.weightedValue
                || this.infractionModel.serious.range.min !== this.model[this.infraction].serious.range.min
                || this.infractionModel.serious.range.max !== this.model[this.infraction].serious.range.max
                || this.infractionModel.serious.weightedValue !== this.model[this.infraction].serious.weightedValue
            )
        },
        /**
         * Nombre de la infracción seleccionada para editar
         */
        infractionName () {
            switch (this.infraction) {
                case 'hardBraking':
                    return this.$t('scoring.editDialog.hardBraking')
                case 'acceleration':
                    return this.$t('scoring.editDialog.acceleration')
                case 'corneringAcceleration':
                    return this.$t('scoring.editDialog.corneringAcceleration')
                case 'disconnection':
                    return this.$t('scoring.editDialog.disconnection')
                default:
                    return ''
            }
        }
    },
    created () {
    },
    mounted () {
    },
    methods: {
        /**
         * actions del dialog
         */
        ...mapActions('dialog', [
            'openDialog',
            'closeDialog'
        ]),
        /**
         * Para restablacer los campos del formulario
         */
        resetFields () {
            this.infraction = null
            this.infractionModel.sligth.range.min = null
            this.infractionModel.sligth.range.max = null
            this.infractionModel.sligth.weightedValue = null
            this.infractionModel.medium.range.min = null
            this.infractionModel.medium.range.max = null
            this.infractionModel.medium.weightedValue = null
            this.infractionModel.serious.range.min = null
            this.infractionModel.serious.range.max = null
            this.infractionModel.serious.weightedValue = null

            if (this.$refs.scoringSecondLevelInfractionForm) {
                this.$refs.scoringSecondLevelInfractionForm.resetValidation()
            }
        },
        /**
         * Para mostrar la tabla de resumen
         */
        showSummaryTable () {
            if (this.notSaved) {
                this.openDialog({
                    title: this.$t('scoring.notSavedTitle'),
                    text: this.$t('scoring.notSavedText'),
                    type: DialogType.WARNING,
                    overlayOpacity: 0.5,
                    actionButtons: true,
                    yesAction: async () => {
                        this.resetFields()
                        this.model.showForm = false
                    },
                    noAction: () => {}
                })
            } else {
                this.resetFields()
                this.model.showForm = false
            }
        },
        /**
         * Para mostrar la tabla de resumen
         */
        showForm () {
            this.model.showForm = true
        },
        /**
         * Cuando se presiona un botón editar de una fila de la tabla
         * @param {*} infraction 
         */
        edit (infraction) {
            this.infraction = infraction
            this.infractionModel.sligth.range.min = this.model[infraction].sligth.range.min
            this.infractionModel.sligth.range.max = this.model[infraction].sligth.range.max
            this.infractionModel.sligth.weightedValue = this.model[infraction].sligth.weightedValue
            this.infractionModel.medium.range.min = this.model[infraction].medium.range.min
            this.infractionModel.medium.range.max = this.model[infraction].medium.range.max
            this.infractionModel.medium.weightedValue = this.model[infraction].medium.weightedValue
            this.infractionModel.serious.range.min = this.model[infraction].serious.range.min
            this.infractionModel.serious.range.max = this.model[infraction].serious.range.max
            this.infractionModel.serious.weightedValue = this.model[infraction].serious.weightedValue

            if (this.$refs.scoringSecondLevelInfractionForm) {
                this.$refs.scoringSecondLevelInfractionForm.resetValidation()
            }

            this.showForm()
        },
        /**
         * Guarda los cambios realizados a la infracción 
         */
        save () {
            this.model[this.infraction].sligth.range.min = this.infractionModel.sligth.range.min
            this.model[this.infraction].sligth.range.max = this.infractionModel.sligth.range.max
            this.model[this.infraction].sligth.weightedValue = this.infractionModel.sligth.weightedValue
            this.model[this.infraction].medium.range.min = this.infractionModel.medium.range.min
            this.model[this.infraction].medium.range.max = this.infractionModel.medium.range.max
            this.model[this.infraction].medium.weightedValue = this.infractionModel.medium.weightedValue
            this.model[this.infraction].serious.range.min = this.infractionModel.serious.range.min
            this.model[this.infraction].serious.range.max = this.infractionModel.serious.range.max
            this.model[this.infraction].serious.weightedValue = this.infractionModel.serious.weightedValue

            this.showSummaryTable()
        }
    },
    watch: {
        tableValidForm(newVal, oldVal){
            if(newVal!==oldVal){
                this.$emit('update:validForm', newVal)
            }
        },
        /*
        infractionValidForm(newVal, oldVal){
            if(newVal!==oldVal){
                this.$emit('update:validForm', newVal)
            }
        },
        */
        /**
         * Para restablecer las validaciones del formulario
         * @param {*} newVal
         */
        resetFormValidation(newVal) {
            if (newVal  && this.$refs.scoringSecondLevelTableForm) {
                this.$refs.scoringSecondLevelTableForm.resetValidation()
            }
            if (newVal  && this.$refs.scoringSecondLevelInfractionForm) {
                this.$refs.scoringSecondLevelInfractionForm.resetValidation()
            }
        }
    }
}
